import React from "react";
import {
  Dialog,
  DialogContent,
  Box,
  DialogTitle,
  Typography,
} from "@mui/material";
import XIcon from "../../icons/X";
const LoginErrorModal = ({
  loginErrorModalState,
  handleLoginErrorModalClose,
  errorMessage,
}) => {
  return (
    <Dialog open={loginErrorModalState}>
      <DialogTitle id="scroll-dialog-title">
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box></Box>
          <Box>
            <XIcon
              data-testid="close-modal-icon"
              sx={{ color: "#C0CBDE", cursor: "pointer" }}
              onClick={handleLoginErrorModalClose}
            />
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ pb: 3 }}>
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Box
              sx={{
                height: "15px",
                width: "15px",
                borderRadius: "15px",
                backgroundColor: "#f00",
                mx: 1,
              }}
            ></Box>
            <Box
              sx={{
                height: "15px",
                width: "15px",
                borderRadius: "15px",
                backgroundColor: "#f00",
                mx: 1,
              }}
            ></Box>
            <Box
              sx={{
                height: "15px",
                width: "15px",
                borderRadius: "15px",
                backgroundColor: "#f00",
                mx: 1,
              }}
            ></Box>
          </Box>
          <Box sx={{ mt: 2 }}>
            <Typography
              align="center"
              sx={{
                fontSize: "18px",
                lineHeight: "36px",
                fontWeight: "bold",
                color: "#f45",
              }}
            >
              Login Failed
            </Typography>
            <Typography
              sx={{
                fontSize: "14px",
                lineHeight: "24px",
                fontWeight: "bold",
                color: "#333",
                mt: 1,
              }}
              align="center"
            >
              {errorMessage}
            </Typography>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default LoginErrorModal;
